import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 货款统计
 */
class PaymentType extends UltMeta {
    INCOME = new Meta(2, "收入");
    EXPENSE = new Meta(1, "支出");
}

export const PAYMENT_TYPE = new PaymentType();

/**
 * 数据来源
 */
class DataSources extends UltMeta {
    TOTAL = new Meta(1, "全部来源");

    SAAS = new Meta(2, "SAAS");

    INDEPENDENCE_DEPLOYMENT = new Meta(3, "独立部署");
}
export const DATA_SOURCES = new DataSources();
